/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

// @mui material components
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

// Material Dashboard 2 React example components
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import MDInput from "components/MDInput"
import { Link } from "react-router-dom"
import { FormControl, InputLabel, Select, Tooltip } from "@mui/material"
import { MenuItem } from "@mui/material"
import { Checkbox, FormControlLabel, TextField } from "@mui/material"

import { showToast } from "utils/swalToast"

// Importa el servicio
import { fetchPost, fetchEventoById, updateEvento, fetchEmpresa } from "./service"
import AddColumnasVista from "./addColumnasVista"

function Add() {
  const [eventoToEdit, setEventoToEdit] = useState(null)
  const navigate = useNavigate()
  const { id } = useParams()
  const [formData, setFormData] = useState({
    empresa: "",
    descripcion: "",
    direccion: "",
    codigoEvento: "",
    telefono: "",
    activo: true,
  })
  const [option, setOption] = useState("")
  const [empresas, setEmpresas] = useState([])
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    fetchEmpresa().then((data) => {
      setEmpresas(data)
    })

    if (id) {
      fetchEventoById(id).then((su) => {
        setEventoToEdit(su)
        setFormData({
          descripcion: su.descripcion || "",
          ciudad: su.ciudad || "",
          codigoEvento: su.codigoEvento || "",
          direccion: su.direccion || "",
          telefono: su.telefono || "",
          activo: su.activo || "",
          empresa: su.empresa || "",
        })
        setOption(su.empresa.idEmpresa)
      })
    }
  }, [id])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const data = {
      descripcion: e.target.descripcion.value,
      direccion: e.target.direccion.value,
      telefono: e.target.telefono.value,
      codigoEvento: formData.codigoEvento,
      activo: Boolean(formData.activo),
      empresa: { idEmpresa: parseInt(option, 10) },
    }

    try {
      if (eventoToEdit) {
        await updateEvento(id, data)
        showToast({ title: "Evento actualizado exitosamente", icon: "success" })
      } else {
        await fetchPost(data)
        showToast({ title: "Evento agregado exitosamente", icon: "success" })
      }
      navigate("/eventos")
    } catch (error) {
      console.error("Error en la operación:", error)
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h5">
                  {eventoToEdit ? "Editar evento" : "Agregar evento"}
                </MDTypography>
              </MDBox>

              {id && (
                <MDBox px={2}>
                  <Tabs
                    value={activeTab}
                    onChange={(_, v) => setActiveTab(v)}
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                      "& .MuiTab-root": {
                        borderRadius: "8px 8px 0 0",
                        transition: "background-color 0.2s",
                      },
                      "& .Mui-selected": {
                        backgroundColor: "#4caf50",
                        color: "#fff !important",
                        borderRadius: "8px 8px 0 0",
                      },
                      "& .MuiTabs-indicator": { display: "none" },
                    }}
                  >
                    <Tab label="General" />
                    <Tab label="Configuración de Vistas" />
                  </Tabs>
                </MDBox>
              )}

              {activeTab === 0 && (
                <MDBox
                  pt={2}
                  px={2}
                  id="formAddUs"
                  onSubmit={handleSubmit}
                  component="form"
                  role="form"
                >
                  <MDBox mb={2}>
                    <FormControl fullWidth required>
                      <InputLabel>Empresa</InputLabel>
                      <Select
                        type="text"
                        name="empresas"
                        value={option}
                        label="Empresas"
                        onChange={(e) => setOption(e.target.value)}
                        fullWidth
                        displayEmpty
                        sx={{ p: 1.5 }}
                      >
                        {empresas.map((empre) => (
                          <MenuItem key={empre.idEmpresa} value={empre.idEmpresa}>
                            {empre.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      required
                      type="text"
                      name="descripcion"
                      label="Nombre de la evento"
                      fullWidth
                      value={formData.descripcion}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      name="direccion"
                      label="Dirección"
                      fullWidth
                      value={formData.direccion}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      name="telefono"
                      label="Teléfono"
                      fullWidth
                      value={formData.telefono}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <MDInput
                      type="text"
                      name="codigoEvento"
                      label="Código de Evento"
                      fullWidth
                      value={formData.codigoEvento}
                      onChange={handleChange}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="activo"
                          checked={Boolean(formData.activo)}
                          onChange={(e) =>
                            handleChange({
                              target: { name: "activo", value: e.target.checked },
                            })
                          }
                        />
                      }
                      label="ACTIVO"
                    />
                  </MDBox>
                  <MDBox mb={2} sx={{ textAlign: "center" }}>
                    <Link to="/eventos">
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        sx={{ mr: 1, width: 90 }}
                      >
                        Cancelar
                      </MDButton>
                    </Link>
                    <MDButton type="submit" variant="gradient" color="info" sx={{ ml: 1, width: 90 }}>
                      {eventoToEdit ? "Actualizar" : "Agregar"}
                    </MDButton>
                  </MDBox>
                </MDBox>
              )}

              {activeTab === 1 && id && <AddColumnasVista id={id} />}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Add
